import { getCsrfToken } from './auth';

/**
 * The Traceability Dashboard API (`/api/matrix/{id}/dashboard*`, v4.27.0). Building and
 * refreshing are the coverage funnel's own routes — one background build serves both views.
 * Same contract as `riskApi.js`: CSRF on every write, FastAPI's `detail` as the error message.
 */
async function call(method, url, body) {
  const opts = { method, headers: {}, credentials: 'include', cache: 'no-store' };
  if (body !== undefined) {
    opts.headers['Content-Type'] = 'application/json';
    opts.body = JSON.stringify(body);
  }
  if (method !== 'GET') opts.headers['X-CSRF-Token'] = getCsrfToken();
  const res = await fetch(url, opts);
  let data = null;
  try { data = await res.json(); } catch (_) { /* a 500 can arrive as HTML */ }
  if (!res.ok) {
    const err = new Error(data?.detail || `Request failed (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return data;
}

const q = (params) => {
  const s = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '' && v !== false) s.set(k, v);
  });
  const str = s.toString();
  return str ? `?${str}` : '';
};

const base = (id) => `/api/matrix/${id}`;

export const traceDashApi = {
  summary: (id) => call('GET', `${base(id)}/dashboard`),
  rows: (id, params) => call('GET', `${base(id)}/dashboard/rows${q(params)}`),
  // Build = the funnel's smart refresh (re-reads only what changed; a full read the first time).
  build: (id) => call('POST', `${base(id)}/funnel/smart-refresh`),
  job: (jobId) => call('GET', `/api/matrix/export-jobs/${jobId}`),
  baselines: (id) => call('GET', `${base(id)}/dashboard/baselines`),
  takeBaseline: (id, body) => call('POST', `${base(id)}/dashboard/baselines`, body),
  archiveBaseline: (id, bid, archived) =>
    call('POST', `${base(id)}/dashboard/baselines/${bid}/archive${q({ archived: archived ? 'true' : 'false' })}`),
  compare: (id, a, b) => call('GET', `${base(id)}/dashboard/compare${q({ a, b })}`),
  analyse: (id, body) => call('POST', `${base(id)}/dashboard/compare/analysis`, body),
};
